<div class="modal-background" (click)="close($event)"></div>
<div class="modal-container">
    <ng-content></ng-content>
</div>
